import { render } from "./MainOne.vue?vue&type=template&id=cbebcff6&scoped=true"
import script from "./MainOne.vue?vue&type=script&lang=js"
export * from "./MainOne.vue?vue&type=script&lang=js"

import "@/assets/css/MainOne.css?vue&type=style&index=0&id=cbebcff6&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbebcff6"]])

export default __exports__